import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import App from './App';
import './index.css';

// --- FIX for annoying ResizeObserver loop warning ---
const resizeObserverErrMsg = "ResizeObserver loop completed with undelivered notifications.";
const resizeObserverHandler = (e) => {
  if (e.message === resizeObserverErrMsg) {
    e.stopImmediatePropagation();
  }
};
window.addEventListener("error", resizeObserverHandler);
window.addEventListener("unhandledrejection", (e) => {
  if (e.reason && e.reason.message === resizeObserverErrMsg) {
    e.stopImmediatePropagation();
  }
});

// --- render app ---
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
